<template>
    <li class="MenuItem">
        <router-link
            v-if="type==='router-link'"
            :to="{name: routeName}"
            :class="{'active': isActive}"
        >
            <slot />
        </router-link>
        <a
            v-else
            :href="routeName"
        >
            <slot />
        </a>
    </li>
</template>

<script>
export default {
    props: {
        routeName: {
            type: String,
            required: true,
        },
        type: {
            type: String,
            default: 'router-link',
        }
    },
    data: () => ({
        isActive: false,
    }),
    watch: {
        $route(to) {
            this.isRouteActive(to);
        },
    },
    mounted() {
        this.isRouteActive(this.$router.currentRoute);
    },
    methods: {
        isRouteActive(to) {
            this.isActive = [to.name, to.meta?.activeRoute].includes(this.routeName);
        },
    },
};
</script>

<style lang="scss">
.MenuItem {
    margin-bottom: 12px;
    &:last-child{
        margin-bottom: 0;
    }
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    border-radius: 10px;
    font-family: $font-lato;
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 22px;

    display: flex;
    align-items: center;
    letter-spacing: 0.3px;
    color: $color-f2m-purple;

    a {
        padding: 12px 8px;
        text-decoration: none;
        color: $color-f2m-purple;
        display: flex;
        gap: 15px;
        align-items: center;
        width: 100%;
        .menuItem-icon{
            transition: all 0.2s ease-in-out;
            &:not([fill="none"]) {
                fill: $color-f2m-purple-icon;
            }
            &[stroke] {
                stroke: $color-f2m-purple-icon;
            }

            margin-right: 20px;
        }
        span {
            font-size: 24px
        }
    }

    &:hover, &:has(> a.active) {
        background-color: $color-f2m-pink-background;
        color: $color-f2m-pink;
        a {
            color: $color-f2m-pink;
            .menuItem-icon{
                &:not([fill="none"]) {
                    fill: $color-f2m-pink;
                }
                &[stroke] {
                    stroke: $color-f2m-pink;
                }
            }
        }
    }

}
</style>
